import React, { useState, useEffect } from 'react'
import { parseISO, addHours } from 'date-fns'
import { format } from 'date-fns-tz'
import ReactVivus from 'react-vivus'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck, faMapMarkedAlt, faUsers } from '@fortawesome/free-solid-svg-icons'

import $ from 'jquery'

import api from '../service/api'

import '../css/Home.css'
import { fillSvg } from '../scripts/util.js'

import NavBar from '../components/navbar'
import Footer from '../components/footer'
import Cards from '../components/cards'

import projectManagement from '../images/project-management.svg'

export default function Home() {

    const [noticias, setNoticias] = useState([])
    const [eventos, setEventos] = useState([])

    useEffect(() => {
        async function loadNoticias() {
            const responseNoticias = await api.get('/open/noticias?sort=-data&limit=5')
            setNoticias(responseNoticias.data)

            const responseEventos = await api.get('/open/eventos?sort=-data&limit=5')
            setEventos(responseEventos.data)
        }

        loadNoticias()
    }, [])

    function formatData(data) {
        const parsedDate = parseISO(data)
        const addedDate = addHours(parsedDate, 3)
        return format(addedDate, 'dd/MM/yyyy', {
            timeZone: 'America/Sao_Paulo',
        })
    }

    function showPalestrantes(palestrantes) {
        if (palestrantes.length === 0)
            return 'Palestrantes não informados'

        let texto = ''

        palestrantes.length > 1
            ? texto = 'Palestrantes: '
            : texto = 'Palestrante: '

        palestrantes.map(palestrante => (
            texto += palestrante.nome + ` (${palestrante.curriculo}), `
        ))

        return texto.substring(0, texto.length - 2)
    }

    $('#modalNoticiaDetalhes').on('show.bs.modal', function (event) {
        let card = $(event.relatedTarget)
        let noticiaIndex = card.data('noticia') // Extrai informação dos atributos data-*

        let modal = $(this)

        if (noticias.length > 0) {
            modal.find('#titulo').text(noticias[noticiaIndex].titulo)
            modal.find('#data').text(`Pubicado em: ${formatData(noticias[noticiaIndex].data)}`)
            modal.find('#descricao').text(noticias[noticiaIndex].descricao)
            modal.find('img').prop('src', api.defaults.baseURL + noticias[noticiaIndex].fotoUrl)
        }
    })

    $('#modalEventoDetalhes').on('show.bs.modal', async function (event) {
        let card = $(event.relatedTarget)
        let eventoIndex = card.data('evento')

        let modal = $(this)

        if (eventos.length > 0) {
            modal.find('#nome').text(eventos[eventoIndex].nome)
            modal.find('#local').text(eventos[eventoIndex].local)
            modal.find('#data').text(formatData(eventos[eventoIndex].data))
            modal.find('#palestrantes').text(showPalestrantes(eventos[eventoIndex].palestrantes))
            modal.find('#descricao').text(eventos[eventoIndex].descricao)
            modal.find('img').prop('src', api.defaults.baseURL + eventos[eventoIndex].fotoUrl)
        }
    })

    return (
        <div id="home">
            <NavBar bgColor='rgb(68, 1, 91)' transparent animate
                navLinks={{
                    "O inove": "#missao",
                    "Pilares": "#pilares",
                    "Eventos": "#eventos-content",
                    // "Editais": "/editais",
                    "Fale Conosco": "#contato"
                }}
            />

            {/*Apresentação */}
            <div className="w-100 text-white" style={{ backgroundColor: "rgba(68, 1, 91, .6)" }, { height: "90%" }}>

                <div className="text-center h-100 m-0 p-0 row justify-content-center align-items-center">
                    <div className="texto-apresentacao column w-100">
                        <div className="row justify-content-center  m-0 p-0">
                            <p className="font-weight-bold mr-3 anim-up">
                                Olá!
                </p>
                            <p className="font-weight-bold anim-left">
                                Somos o INOVE
                </p>
                        </div>
                        <p className="anim-right top-p">
                            Núcleo de inovação e empreendedorismo<br />
              do campus da UFC em Quixadá
              </p>
                    </div>
                </div>
            </div>


            {/*Missão */}
            <div id="missao" className="text-center" style={{ backgroundColor: "rgb(68, 1, 91)" }}>
                <div className="row  mx-auto" style={{ padding: "10%", overflow: "hidden" }}>
                    <ReactVivus
                        className="col-sm-6 mb-4 mx-auto"
                        id="insight"
                        option={{
                            file: projectManagement,
                            animTimingFunction: 'EASE',
                            type: 'sync',
                            duration: 100
                        }}
                        style={{ height: '200px', width: '200px' }}
                        callback={fillSvg}
                    />

                    <div className="col-sm-6" >
                        <div className="row text-white justify-content-center align-items-center h-100">
                            <h3 className="mb-3 font-weight-bold">Nossa missão</h3>
                            <h5 id="h5-home">Fomentar o desenvolvimento tecnológico e social da Região do Sertão Central e Estado do Ceará, atuando na
                            pesquisa e desenvolvimento de ciência e tecnologia, e na geração de novos empreendimentos, de forma integrada
                            e
                            auto-sustentada com a sociedade.
              </h5>
                        </div>
                    </div>
                </div>
            </div>

            {/*Pilares */}
            <Cards />

            {/*Notícias */}
            <div className="noticias-content p-5" style={{ backgroundColor: "rgb(68, 1, 91)" }}>

                <h3 className="font-weight-bold text-white text-center">Notícias</h3>

                <div className="card-deck mt-3 justify-content-center">

                    {noticias.length > 0
                        ? noticias.map((noticia, indice) => (
                            <div key={noticia._id} className="card col-sm-2 p-0 border-0 shadow-lg">
                                <img data-toggle="modal" data-target="#modalNoticiaDetalhes" height="250px" data-noticia={indice} className="card-img-top" src={api.defaults.baseURL + noticia.fotoUrl} alt="" />
                                <div className="card-body">
                                    <h5 id="titulo" className="card-title font-weight-bold">{noticia.titulo}</h5>
                                    <p id="descricao" className="card-text">{noticia.descricao.substring(0, 100)}...</p>

                                    <p id="data" className="card-text">
                                        <small className="text-muted">Publicado em: {formatData(noticia.data)}</small>
                                    </p>
                                </div>
                            </div>
                        ))
                        : <p className="text-white text-center">Não há noticias cadastradas</p>
                    }
                </div>

                <p className="text-center pt-5 m-0 font-weight-bold">
                    <a className="text-white" href="/noticias">Ver Mais</a>
                </p>

            </div>

            {/*Modal Noticias */}
            <div className="modal fade" id="modalNoticiaDetalhes" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header" style={{ backgroundColor: "#eee" }}>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">

                            <div className="card">
                                <img data-toggle="modal" data-target="#modalTesteNoticia" className="card-img-top" alt="" />
                                <div className="card-body">
                                    <h5 id="titulo" className="pb-0  mb-0 card-title font-weight-bold display-4">Título</h5>
                                    <span id="data" className="card-text text-muted my-0 py-0">Data</span>

                                    <p id="descricao" className="card-text mt-4" align="justify">Descrição</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Eventos */}
            <div id="eventos-content" className="p-5">

                <h3 className="font-weight-bold text-center" style={{ color: "rgb(68, 1, 91)" }}>Eventos</h3>

                <div className="card-deck mt-3 justify-content-center">
                    {eventos.length > 0
                        ? eventos.map((evento, indice) => (
                            <div key={evento._id} className="card col-sm-2 p-0 border-0 shadow-lg">
                                <img data-toggle="modal" data-evento={indice} data-target="#modalEventoDetalhes" height="250px" className="card-img-top" src={api.defaults.baseURL + evento.fotoUrl} alt="" />
                                <div className="card-body">
                                    <h5 id="nome" className="card-title font-weight-bold">{evento.nome}</h5>
                                    <p id="descricao" className="card-text">{evento.descricao.substring(0, 100)}...</p>
                                </div>
                                <div className="card-footer">
                                    <p id="data" className="card-text">
                                        <FontAwesomeIcon icon={faCalendarCheck} style={{ color: "rgb(68, 1, 91)" }} /> {formatData(evento.data)}
                                    </p>

                                    <p id="local" className="card-text">
                                        <FontAwesomeIcon icon={faMapMarkedAlt} style={{ color: "rgb(68, 1, 91)" }} /> {evento.local}
                                    </p>
                                </div>
                            </div>
                        ))
                        : <p className="text-center">Não há eventos cadastrados.</p>
                    }
                </div>

                <p className="text-center pt-5 m-0 font-weight-bold">
                    <a style={{ color: "rgb(68, 1, 91)" }} href="/eventos">Ver Todos</a>
                </p>
            </div>

            {/**Modal evento */}
            <div className="modal fade" id="modalEventoDetalhes" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header" style={{ backgroundColor: "#eee" }}>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="card">
                                <img className="card-img-top" alt="" />
                                <div className="card-body">
                                    <h5 id="nome" className="pb-0  mb-0 card-title font-weight-bold display-4">Título </h5>
                                    <div className="m-0 p-0">
                                        <FontAwesomeIcon className="mr-2" icon={faCalendarCheck} style={{ color: "rgb(68, 1, 91)" }} />
                                        <p id="data" className="card-text d-inline" /> <br />

                                        <FontAwesomeIcon className="mr-2" icon={faMapMarkedAlt} style={{ color: "rgb(68, 1, 91)" }} />
                                        <p id="local" className="card-text d-inline" /> <br />

                                        <FontAwesomeIcon className="mr-2" icon={faUsers} style={{ color: "rgb(68, 1, 91)" }} />
                                        <p id="palestrantes" className="card-text d-inline" /> <br />
                                    </div>
                                    <p id="descricao" className="card-text mt-4">Descrição</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}
